module.exports = __webpack_public_path__ + "img/addButton.423c4b58.svg";